import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);


class Retailers extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


    this.ref = {
      retail: null
    }

    console.log('sdadasdasdas');

  }

  mount() {
        
        

        ScrollTrigger.create({
            trigger: this.ref.retail,
            start: "top top",
            pin: true
        });


 }

  unmount() {




  }
}




module.exports = Retailers
